import React from 'react'
import styled from 'styled-components';
import { FaStar, FaStarHalfAlt } from "react-icons/fa";
import { AiOutlineStar } from "react-icons/ai";

const Star = ({stars, reviews}) => {
    const starDiagram = Array.from({length: 5}, (ele, index) => {
        let numbers = index + 0.5;
        return(
            <span key={index} >
                {stars >= index + 1
                ? <FaStar className="icon" />
                : stars >= numbers
                    ? <FaStarHalfAlt className="icon" />
                    : <AiOutlineStar className="icon" />
                }
            </span>
        );
    })
  return (
    <Wrapper>
        <div className="icon-style">
            {starDiagram}
            <p className="white">{reviews} reviews</p>
        </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  .icon-style {
    display: flex;
    gap: 0.2rem;
    align-items: center;
    justify-content: flex-start;

    .icon {
      font-size: 2rem;
      color: yellow;
    }

    .empty-icon {
      font-size: 2.6rem;
    }
    p {
      margin: 0;
      padding-left: 1.2rem;
    }
  }
`;

export default Star;